export type Translator = (
	key: string,
	params?: Record<string, unknown>
) => string;

/** Anything selectable on an axis: verticals, dimensions and metrics all carry one. */
type NamedProperty = { name_clean: string };

/** Names spelled out before the rest collapse into a count. */
const NAME_LIMIT = 3;

/**
 * The footer summary for a selection: the selected property titles, collapsing
 * to "{named} and {count} more" past `limit` so a wide selection can't outgrow
 * the footer. Takes a single selection or a list, so single- and multi-select
 * axes read the same.
 */
export const summarizeSelection = (
	selection: NamedProperty | NamedProperty[] | null | undefined,
	{ t, limit = NAME_LIMIT }: { t: Translator; limit?: number }
): string => {
	const selected = Array.isArray(selection)
		? selection
		: [selection].filter(Boolean);

	const names = selected
		.filter((item): item is NamedProperty => Boolean(item?.name_clean))
		.map((item) => t(`properties.${item.name_clean}.title`));

	if (names.length === 0) {
		return t("axisDialog.summary.empty");
	}

	if (names.length <= limit) {
		return names.join(", ");
	}

	return t("axisDialog.summary.overflow", {
		named: names.slice(0, limit).join(", "),
		count: names.length - limit,
	});
};
